import React from 'react'
import { Controller, useFormContext } from 'react-hook-form'
import Box from '@material-ui/core/Box'
import { gendersList } from 'components/coaches-profile/constants'
import TextField from '@material-ui/core/TextField'
import MenuItem from '@material-ui/core/MenuItem'
import {
  getFieldProps,
  requiredLabel,
  useCreateProfileFieldStyles,
} from '../create-profile-form/field-styles'

export const AboutYou = ({ memberProfile }) => {
  const classes = useCreateProfileFieldStyles()
  const fieldProps = getFieldProps(classes)
  const { register, errors, control } = useFormContext()

  const renderTextField = ({ name, label, isRequired, placeholder }) => (
    <TextField
      {...fieldProps}
      name={name}
      label={isRequired ? requiredLabel(label) : label}
      placeholder={placeholder}
      type="text"
      inputRef={register()}
      defaultValue={memberProfile?.[name] || ''}
      error={!!errors[name]}
      helperText={errors[name]?.message}
    />
  )

  const renderSelectField = ({ name, label, menuList }) => (
    <Controller
      name={name}
      control={control}
      render={({ value, onChange }) => (
        <TextField
          {...fieldProps}
          select
          name={name}
          label={label}
          value={value ?? ''}
          error={!!errors[name]}
          helperText={errors[name]?.message}
          onChange={event => {
            const selectedValue = event.target.value
            onChange(selectedValue === '' ? null : selectedValue)
          }}
          className={classes.selectInput}
        >
          {menuList.map(opt => (
            <MenuItem key={opt.value ?? 'none'} value={opt.value ?? ''}>
              {opt.label}
            </MenuItem>
          ))}
        </TextField>
      )}
    />
  )

  return (
    <Box className={classes.fieldStack}>
      <Box className={classes.fieldRow}>
        {renderTextField({
          name: 'firstName',
          label: 'First Name',
          isRequired: true,
        })}
        {renderTextField({
          name: 'lastName',
          label: 'Last Name',
          isRequired: true,
        })}
      </Box>
      {renderTextField({
        name: 'displayName',
        label: 'Display Name',
      })}
      {renderTextField({
        name: 'title',
        label: 'Professional Title',
        placeholder: 'e.g., Director of Instruction, Head Golf Professional',
      })}
      {renderSelectField({
        name: 'gender',
        label: 'Gender',
        menuList: gendersList,
      })}
    </Box>
  )
}

export default AboutYou
